<script setup>
const props = defineProps(['width']);
const width = props.width ? props.width : 100;
</script>
<template>
    <img :width="width" src="/img/poligrama_logo.svg" alt="PoliGrama"/>
</template>